import * as AccordionPrimitive from "@radix-ui/react-accordion"
import { ChevronDown } from "lucide-react"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"
import { cn } from "../lib/utils"

export function AccordionRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()

  const handleValueChange = (value: string | string[]) => {
    dispatchEvent(element.id, "toggle", { value })
  }

  return (
    <AccordionPrimitive.Root
      type="multiple"
      className={cn("w-full", element.className)}
      data-testid={`accordion-${element.id}`}
      onValueChange={handleValueChange}
    >
      {element.children?.map((section, index) => {
        const title = section.text
          ? String(resolveSymbol(section.text) ?? "")
          : `Section ${index + 1}`

        return (
          <AccordionPrimitive.Item key={section.id} value={section.id} className="border-b">
            <AccordionPrimitive.Header className="flex">
              <AccordionPrimitive.Trigger className="flex flex-1 items-center justify-between py-4 px-4 text-sm font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180">
                {title}
                <ChevronDown className="h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" />
              </AccordionPrimitive.Trigger>
            </AccordionPrimitive.Header>
            <AccordionPrimitive.Content className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
              <div className="pb-4 pt-0 px-4">
                {section.children?.map((child) => (
                  <ElementRenderer key={child.id} element={child} />
                ))}
              </div>
            </AccordionPrimitive.Content>
          </AccordionPrimitive.Item>
        )
      })}
    </AccordionPrimitive.Root>
  )
}
